import { render, staticRenderFns } from "./AccountAdd.vue?vue&type=template&id=117dbc73&"
import script from "./AccountAdd.vue?vue&type=script&lang=ts&"
export * from "./AccountAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117dbc73')) {
      api.createRecord('117dbc73', component.options)
    } else {
      api.reload('117dbc73', component.options)
    }
    module.hot.accept("./AccountAdd.vue?vue&type=template&id=117dbc73&", function () {
      api.rerender('117dbc73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/AccountAdd.vue"
export default component.exports